import defaultWebModal from '#themes/default/web/components/modal/modal.js';

import cCross from '#themes/avast/web/components/cross/cross.js';
import cOfferModal from '#themes/avast/web/components/offerModal/offerModal.js';
import cPaymentFailedModal from '#themes/avast/web/components/paymentFailedModal/paymentFailedModal.js';

export default {
	name: 'CModal',
	components: {
		cCross,
		cOfferModal,
		cPaymentFailedModal
	},
	extends: defaultWebModal
};
